import { useState } from "react";
import { LogOut, User } from "lucide-react";
import "../styles/department-base.css";

export default function DepartmentTopBar({ deptUser, departmentLabel, onLogout }) {
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);

  const displayName = deptUser
    ? [deptUser.firstName, deptUser.lastName].filter(Boolean).join(" ") || deptUser.email
    : "Department User";

  const handleLogoutClick = () => {
    setLogoutConfirmOpen(true);
  };

  return (
    <>
      <header className="dept-topbar">
        <div className="dept-topbar__left">
          <span className="dept-topbar__title">{departmentLabel}</span>
        </div>
        <div className="dept-topbar__right">
          <span className="dept-topbar__user">
            <User size={16} />
            <span>{displayName}</span>
          </span>
          <button
            type="button"
            className="dept-topbar__logout-btn"
            onClick={handleLogoutClick}
            title="Logout"
          >
            <LogOut size={16} />
            <span>Logout</span>
          </button>
        </div>
      </header>

      {logoutConfirmOpen ? (
        <div className="dept-confirm-dialog" role="dialog" aria-modal="true" aria-label="Confirm department logout">
          <button
            type="button"
            className="dept-confirm-dialog__backdrop"
            onClick={() => setLogoutConfirmOpen(false)}
            aria-label="Close logout confirmation"
          />
          <div className="dept-confirm-dialog__panel">
            <h3>Confirm Logout</h3>
            <p>Are you sure you want to log out?</p>
            <div className="dept-confirm-dialog__actions">
              <button
                type="button"
                className="dept-confirm-dialog__button dept-confirm-dialog__button--ghost"
                onClick={() => setLogoutConfirmOpen(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="dept-confirm-dialog__button dept-confirm-dialog__button--danger"
                onClick={() => {
                  setLogoutConfirmOpen(false);
                  onLogout();
                }}
              >
                Log out
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
